/* eslint-disable react/no-array-index-key */
import LoadingIcon from '@components/LoadingIcon';
import { useSelector } from 'react-redux';
import {
  // Root,
  Inner,
  LineItemWrapper,
  AddonWrapper,
  SubscriptionName,
  LineItemName,
  LineItemPrice,
  StartDateWrapper,
  StartDate,
  LoadingIcon as LoadingIconClass,
  IsSkeleton,
  Car as CarClass,
  Text,
  PriceWrapper,
  Total,
  Price as PriceClass,
} from '../../OrderSummary.module.css';

const OrderItemsListSkeleton = () => {
  const { membershipIds = [] } = useSelector((state) => state.checkout);

  const SkeletonMemberships = new Array(membershipIds.length || 1).fill({
    uuid: 1,
    isSkeleton: 1,
    addons: new Array(3).fill({ isSkeleton: true }),
  });

  return (
    <>
      {SkeletonMemberships.map(({ addons }, orderItemIndex) => (
        <div className={Inner} key={orderItemIndex}>
          <div className={IsSkeleton}>
            <div className={CarClass}>
              <div className={LineItemWrapper}>
                <span className={[SubscriptionName, LineItemName].join(' ')}>
                  <span />
                </span>
                <span className={LineItemPrice} />
              </div>
              <div className={StartDateWrapper}>
                <span className={StartDate} />
              </div>
              {addons.map((_, index) => (
                <div
                  key={index}
                  className={[LineItemWrapper, AddonWrapper].join(' ')}
                >
                  <span className={LineItemName}>
                    <span />
                  </span>
                  <span className={LineItemPrice} />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}

      <div className={Total}>
        <div className={PriceWrapper}>
          <span className={Text} />
          <div className={PriceClass}>
            <LoadingIcon noMaxWait className={LoadingIconClass} />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderItemsListSkeleton;
